import type { z } from 'zod';
import { zs } from '@/entities/shared/schemas/zod';

export const taskStatusSchema = zs.enum(['todo', 'doing', 'done', 'dismissed']);

export type TaskStatus = z.infer<typeof taskStatusSchema>;
